import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { updateEntities } from '../utils';
import { dispatchRequest } from '../dispatch-request';
import { VehicleIcon } from '../../core/models/vehicle-icon.model';
import {
  GetVehicleIconsAction,
  GetVehicleIconsSuccessAction,
  GetVehicleIconsFailAction,
} from './vehicle-icon.actions';

export interface VehicleIconStateModel {
  entities: { [key: number]: VehicleIcon };
  ids: number[];
}

@State<VehicleIconStateModel>({
  name: 'vehicleIcon',
  defaults: {
    entities: {},
    ids: [],
  },
})
@Injectable()
export class VehicleIconState {

  constructor(
    private httpClient: HttpClient,
  ) {}

  @Action(GetVehicleIconsAction)
  getVehicleIcons(
    ctx: StateContext<VehicleIconStateModel>,
  ) {
    const request = this.httpClient.get('GetIcons');

    return dispatchRequest(
      request,
      ctx,
      GetVehicleIconsSuccessAction,
      GetVehicleIconsFailAction,
    );
  }

  @Action(GetVehicleIconsSuccessAction)
  getVehicleIconsSuccess(
    ctx: StateContext<VehicleIconStateModel>,
    action: GetVehicleIconsSuccessAction,
  ) {
    const stateUpdate = updateEntities(action.payload, VehicleIcon, 'iconId');
    ctx.patchState(stateUpdate);
  }
}
